// Delete product soin after 30 minutes
class ShopifyCartTimeout {
    constructor(checkIntervalMinutes = 5, templateSuffix = 'soin') {
        this.checkIntervalMinutes = checkIntervalMinutes;
        this.templateSuffix = templateSuffix;
        this.init();
    }

    init() {
        this.startPeriodicCheck();
        this.checkAndRemoveExpiredItems();
    }

    startPeriodicCheck() {
        setInterval(() => {
            this.checkAndRemoveExpiredItems();
        }, this.checkIntervalMinutes * 60 * 1000);
    }

    async checkAndRemoveExpiredItems() {
        const currentTime = Date.now();
        const itemsToRemove = [];

        for (let i = 0; i < localStorage.length; i++) {
            const key = localStorage.key(i);
            if (key.startsWith('cartItem_')) {
                const itemData = JSON.parse(localStorage.getItem(key));
                if (currentTime > itemData.expirationTime) {
                    const variantId = key.split('_')[1];
                    itemsToRemove.push(variantId);
                    localStorage.removeItem(key);
                    console.log(`Item ${variantId} expired and will be removed`);
                } else {
                    itemData.lastChecked = currentTime;
                    localStorage.setItem(key, JSON.stringify(itemData));
                }
            }
        }

        if (itemsToRemove.length > 0) {
            await this.removeItemsFromCart(itemsToRemove);
        }
    }

    async removeItemsFromCart(variantIds) {
        const updates = {};
        variantIds.forEach(id => {
            updates[id] = 0;
        });

        try {
            const response = await fetch('/cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ updates }),
            });

            if (response.ok) {
                window.location.reload();
            } else {
                console.error('Error removing expired items');
            }
        } catch (error) {
            console.error('Error updating cart:', error);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new ShopifyCartTimeout(5, 'soin');
});